
export function OnListErintettOfficesSelectionChanged(s: MVCxClientGridView, e: ASPxClientGridViewRowClickEventArgs) {
    if (e.visibleIndex < 0) {
        return;
    }

    let $submitBtn: JQuery = $('#select-office-submit-button');
    $submitBtn.prop('disabled', false);

    let officeIdInputId: string = $submitBtn.data('selected-office-id-input-id');
    let scopeIdInputId: string = $submitBtn.data('selected-scope-id-input-id');
    let selectedRowKeys: string[] = s.GetRowKey(e.visibleIndex).split('|');

    let officeId: string = selectedRowKeys[0];
    $('#' + officeIdInputId).val(officeId);

    let officeScopeId: string = selectedRowKeys[1];
    $('#' + scopeIdInputId).val(officeScopeId);
}
